module.exports = __webpack_public_path__ + "img/methoden_mitwirkung.2c5bcf23.png";